import { BLOCKS, type Block, type Document, type Inline } from "@contentful/rich-text-types";

import { documentToReactComponents } from "@/shared/lib";

import { Typography } from "./Typography";

export type Replacement = {
    pattern: string;
    replacement: JSX.Element;
};

export function ContentfulText({ document, replacement }: { document?: Document; replacement?: Replacement }) {
    const options = {
        renderNode: {
            [BLOCKS.HEADING_1]: (node: Block | Inline, children: React.ReactNode) => (
                <Typography variant="title1">{children}</Typography>
            ),
            [BLOCKS.HEADING_2]: (node: Block | Inline, children: React.ReactNode) => (
                <Typography variant="title2">{children}</Typography>
            ),
            [BLOCKS.HEADING_3]: (node: Block | Inline, children: React.ReactNode) => (
                <Typography variant="title3">{children}</Typography>
            ),
            [BLOCKS.PARAGRAPH]: (node: Block | Inline, children: React.ReactNode) => (
                <Typography variant="body">{children}</Typography>
            ),
        },
    };
    if (!document) return null;

    const elements = documentToReactComponents(document, options);

    if (replacement) {
        if (!elements || Array.isArray(elements) === false) return elements;

        const updatedElements = elements.map((element) => {
            const firstChild = element.props.children[0];
            if (firstChild == replacement.pattern) {
                return replacement.replacement;
            }
            return element;
        });
        return updatedElements;
    }

    return elements;
}
